export enum DataTypes {
  no_type,
  currency,
  number,
  percentage,
  date,
}

export interface DataType {
  name: DataTypes;
  decimals?: number;
}
